import { createIdentifier } from '@toeverything/infra';

export interface AuthProvider {
  /**
   * Native shells use this to keep the OAuth state-binding cookie in the same
   * native HTTP cookie jar that later completes the code exchange. Providers
   * which do not implement it fall back to the browser fetch path.
   */
  oauthPreflight?(
    provider: string,
    client: string,
    redirectUri: string | undefined,
    clientNonce: string
  ): Promise<Record<string, string>>;

  signInMagicLink(
    email: string,
    token: string,
    clientNonce?: string
  ): Promise<void>;

  signInOauth(
    code: string,
    state: string,
    provider: string,
    clientNonce?: string
  ): Promise<{ redirectUri?: string }>;

  signInPassword(credential: {
    email: string;
    password: string;
    verifyToken?: string;
    challenge?: string;
  }): Promise<void>;

  signOut(): Promise<void>;
}

export const AuthProvider = createIdentifier<AuthProvider>('AuthProvider');
